import {
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_UPDATE_RESET
} from "../constants/productConstants";

export const productDetailReducer = (state = { product: { files: [] } }, action) => {
  switch (action.type) {
    case PRODUCT_DETAILS_REQUEST:
      return { loading: true, ...state };
    case PRODUCT_DETAILS_SUCCESS:
      return { loading: false, product: action.payload };
    case PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productListReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { ...state, loading: true, products: [] }; 

    case PRODUCT_LIST_SUCCESS:
      return {
        loading: false,
        products: action.payload.products,
        pages: action.payload.pages,
        page: action.payload.page,
      };

    case PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload, products: [] };

    default:
      return state;
  }
};

export const productDeleteReducer = (state = {}, action) => {
  switch (action.type) {
      case PRODUCT_DELETE_REQUEST: return { loading: true };
      case PRODUCT_DELETE_SUCCESS: return { loading: false, success: true };
      case PRODUCT_DELETE_FAIL: return { loading: false, error: action.payload };
      default: return state;
  }
};

export const productUpdateReducer = (state = { product: {} }, action) => {
  switch (action.type) {
      case PRODUCT_UPDATE_REQUEST: return { loading: true };
      case PRODUCT_UPDATE_SUCCESS: return { loading: false, success: true, product: action.payload };
      case PRODUCT_UPDATE_FAIL: return { loading: false, error: action.payload };
      case PRODUCT_UPDATE_RESET: return { product: {} };
      default: return state;
  }
};